import { ApisauceInstance, create } from 'apisauce';

import type { Authentication } from '@barboxx/models/types';

interface ApiProps extends ApisauceInstance {
    setKioskInfo: (data: { lockerId: number }) => void;
    setTokenInfo: (data: Authentication.TokenInfo) => void;
    clearTokenInfo: () => void;
    setDeviceInfo?: (data: {
        device: string;
        ip: string;
        os: string;
        appVersion: string;
    }) => void;
}

export const api = create({
    baseURL: '/v1',
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 30000,
}) as ApiProps;

const bearerToken = (token: any) => `Bearer ${token}`;

api.setTokenInfo = ({ expiresAt, token }) => {
    api.setHeaders({
        Authorization: bearerToken(token),
        ExpiresAt: expiresAt,
    });
};

api.clearTokenInfo = () => {
    api.deleteHeader('Authorization');
    api.deleteHeader('ExpiresAt');
    api.deleteHeader('LockerId');
};

api.setKioskInfo = ({ lockerId }) => {
    api.setHeaders({
        LockerId: lockerId.toString(),
    });
};

api.setDeviceInfo = ({ device, ip, os, appVersion }) => {
    api.setHeaders({
        Device: device,
        IP: ip,
        OS: os,
        'X-App-Version': appVersion,
    });
};
